import BASE from 'config/cfg.base.json'
import PROD from 'config/cfg.prod.json'
import _merge from 'lodash/merge'
import { getConsumerConfig } from './consumers'

const CFG = {}

/**
 * merges the object passed as parameter with the existing config
 * @param {Object} cfg
 */
export function hydrate (cfg) {
    _merge(CFG, cfg)
}

export const buildCfg = async (lang) => {
    const consumerCfg = await getConsumerConfig()
    hydrate(consumerCfg)
    CFG.LANGUAGE = lang
}

hydrate(process.env.NODE_ENV === 'development' ? BASE : _merge(BASE, PROD))

export default CFG
